import { Document, Page, Text, View, Image, Font } from "@react-pdf/renderer";
import { CheckNull, PriceFormat, formatDate, numberToWords, FormatValueDecimal, getStorageData } from "../../../utils/Validate";
import { quoteStyles } from "./QuotePDFStyleSheet";
import { FooterComponent } from "./FooterComponent";
import { HeaderComponent } from "./HeaderComponent"
import { useEffect, useState } from "react";
import FetchData, { GetListAsync, GetOne } from "../../../providers/dataProvider";
import urls from "../../../constants";
import { TermsAndConditionPDF } from "./termsAndConditions";
import { TermsAndConditionFooterComponent } from "./termsAndConditionsFooter"
import { TermsAndConditionHeaderComponent } from "./termsAndConditionsHeader";
import { CurrencyConvertion } from "../../../utils/Validate";
import headerImage from "../../../headerFullImage.png"
import headerImage1 from "../../../CNDistributorHeader.png"
import footerImage from "../../../footerImage.png"
import footerImage1 from "../../../CNDistributorFooter.png"

Font.register({
  family: 'Open Sans',
  src: 'https://fonts.googleapis.com/css2?family=Jura:wght@300..700&family=Open+Sans:ital,wght@0,300..800;1,300..800&display=swap',
});

export const QuotePDF = ({ values, currencyDetail, distributorList }) => {
  const [quotePDFDetails, setQuotePDFDetails] = useState(null);
  const [markDetails, setMarkDetails] = useState([]);
  const [markData, setMarkData] = useState(null);
  const [configData, setConfigData] = useState(null);
  const [variantData, setVariantData] = useState([]);
  const [listData, setListData] = useState([])
  let totalDdp = 0;

  const { data: customerList } = FetchData("Customer");
  const { data: inquiryList } = FetchData("inquiry");
  const { data: assignedEngineerList } = FetchData("userprofile");
  const { data: deliveryTermsList } = FetchData("deliveryterms");
  const { data: paymentTermsList } = FetchData("paymentterms");
  const { data: projectData } = FetchData("project");
  const { data: countryList } = FetchData("country");

  const customerObj = customerList?.find((ob) => ob?.id == quotePDFDetails?.data?.customerId)
  const enquiryObj = inquiryList?.find((ob) => ob?.id == quotePDFDetails?.data?.enquiryId)
  const salesEngObj = assignedEngineerList?.find((ob) => ob?.identityId == quotePDFDetails?.data?.salesEngineerId)
  const projectObj = projectData?.find((ob) => ob?.id == quotePDFDetails?.data?.projectId)
  useEffect(() => {
    if (values?.id) {
      GetOne("quotation", { id: values?.id }, setQuotePDFDetails);
    }
  }, [values?.id]);

  useEffect(() => {
      if (salesEngObj?.id) {
          GetOne("userprofile", { id: salesEngObj?.id }, setListData)
      }
  }, [salesEngObj]);

  useEffect(() => {
    const fetchProductData = async () => {
      const quoteDetails = quotePDFDetails?.data;
      if (quoteDetails?.products) {
        try {
          const configDataPromises = quoteDetails.products.map(item =>
            GetListAsync("productsspecification", { id: item?.productId })
          );

          const configDataResults = await Promise.all(configDataPromises);
          const configResult = configDataResults.filter(result => result?.message === "success")?.map((item) => [...item?.data])?.flat();
          const VariantPromises = quoteDetails.products.map(item =>
            GetListAsync("productsvariants", { id: item?.groupId }).then(result => ({
              markId: item.id, // Attach markId here
              result,
            }))
          );

          const VariantDataResult = await Promise.all(VariantPromises);
          const variantResult = VariantDataResult.filter(result => result?.result?.message === "success");
          setVariantData(variantResult)
          setMarkData(quoteDetails?.products);
          setConfigData(configResult);

          GetMarkDetails(quoteDetails?.products, configResult);
        } catch (error) {
          console.error("Error fetching product data", error);
        }
      }
    };

    fetchProductData(); // Call the async function
  }, [quotePDFDetails]);

  const GetMarkDetails = (markResult, configResult) => {
    if (markResult?.length > 0) {
      let arrayMark = [];
      markResult?.map((item, index) => {
        const productFilterObj = configResult?.filter((config) => config?.productId === item?.productId)
        let arrayAttribute = [];
        item?.productSpecifications?.map((spec) => {
          const findAttribute = productFilterObj?.map((productItem) => productItem?.productSpecMaps)?.flat().filter(specItem => specItem?.attributeId === spec?.specificationId)
          const findvalue = findAttribute?.[0]?.productSpecValueMaps?.filter(valuemap => valuemap?.id === spec?.specificationValueId)
          arrayAttribute.push({ ...spec, attributeName: findAttribute?.[0]?.attributeName, attributeValue: findvalue?.[0]?.valueName })
        })
        arrayMark?.push({ ...item, productSpecifications: arrayAttribute })
      })
      setMarkDetails(arrayMark)
    }
  }

  // Utility function to split array into chunks of four
  const chunkArray = (array, chunkSize) => {
    const result = [];
    for (let i = 0; i < array.length; i += chunkSize) {
      result.push(array.slice(i, i + chunkSize));
    }
    return result;
  };

  // Inside your render or return function
  const renderSpecifications = (mark) => {
    const specChunks = chunkArray(mark?.productSpecifications, 2);
    return specChunks.map((specChunk, rowIndex) => {
      return (
        <View style={quoteStyles.modelProductListTableRow} key={rowIndex}>
          {specChunk.map((specification, specIndex) => (
            <View style={quoteStyles.modelProductListTableColumn} key={specIndex}>
              <Text style={quoteStyles.modelProductListKeyTableCell}>{specification?.attributeName}{" : "}</Text>
              <Text style={quoteStyles.modelProductListValueTableCell}>{specification?.specialValue ? specification?.specialValue : specification?.attributeValue}</Text>
            </View>
          ))}
        </View>
      );
    });
  };

  const getVariantValue = (variantId, prodItem) =>
    prodItem?.productItemVariants?.find(filterItem => variantId.includes(filterItem?.variantId))?.variantValue || "";

  const renderProductHeading = (mark) => {
    let dimensions = "";
    if (urls?.LENGTH_NO_OF_SLOTS_GROUP.includes(mark?.groupId)) {
      if (urls?.LENGTH1_LENGTH2_SLOTS_PRODUCT.includes(mark?.productSubGroupId))
        dimensions = `Dimensions {"\n"} ~ L1 (mm) x L2 (mm) x Slot (mm)`;
      else
        dimensions = `Dimensions {"\n"} ~ L (mm) x Slot (mm) x EndCaps`;
    }
    else if (urls?.LENGTH_HEIGHT_GROUP.includes(mark?.groupId)) {
      if (urls?.MITER_CORNER_PRODUCT_ID === mark?.productSubGroupId)
        dimensions = `Dimensions {"\n"} ~ L1 (mm) x L2 (mm) x H (mm)`;
      else
        dimensions = `Dimensions {"\n"} ~ L (mm) x H (mm)`;
    }
    else if (urls?.WIDTH_HEIGHT_GROUP.includes(mark?.groupId))
      dimensions = `Dimensions {"\n"} W (mm) x H (mm)`;
    else if (urls?.DIAMETER_GROUP.includes(mark?.groupId))
      dimensions = `Dimensions {"\n"} ~ Dia (mm)`;
    else
      return null;

    return (
      <Text style={quoteStyles.modelProductListDetailTableHeadCell}>
        {dimensions}
      </Text>
    );
  };

  const renderProductDetail = (mark, prodItem) => {
    let dimensions = "";

    if (urls?.LENGTH_NO_OF_SLOTS_GROUP.includes(mark?.groupId)) {
      if (urls?.LENGTH1_LENGTH2_SLOTS_PRODUCT.includes(mark?.productSubGroupId))
        dimensions = `${getVariantValue(urls.LENGTH_1, prodItem)} x ${getVariantValue(urls.LENGTH_2, prodItem)} x ${getVariantValue(urls.NO_OF_SLOTS, prodItem)}`;
      else if (urls?.CURVED_LENGTH_PRODUCT_ID.includes(mark?.productSubGroupId))
        dimensions = `${getVariantValue(urls.ARC_LENGTH, prodItem)} x ${getVariantValue(urls.NO_OF_SLOTS, prodItem)} x ${getVariantValue(urls.END_CAPS, prodItem)}`;
      else
        dimensions = `${getVariantValue(urls.LENGTH, prodItem)} x ${getVariantValue(urls.NO_OF_SLOTS, prodItem)} x ${getVariantValue(urls.END_CAPS, prodItem)}`;
    }
    else if (urls?.LENGTH_HEIGHT_GROUP.includes(mark?.groupId)) {
      if (urls?.MITER_CORNER_PRODUCT_ID === mark?.productSubGroupId)
        dimensions = `${getVariantValue(urls.LENGTH_1, prodItem)} x ${getVariantValue(urls.LENGTH_2, prodItem)} x ${getVariantValue(urls.HEIGHT, prodItem)}`;
      else if (urls?.CURVED_LINEARBAR_GRILL_PRODUCT_ID === mark?.productSubGroupId)
        dimensions = `${getVariantValue(urls.ARC_LENGTH, prodItem)} x ${getVariantValue(urls.HEIGHT, prodItem)}`;
      else
        dimensions = `${getVariantValue(urls.LENGTH, prodItem)} x ${getVariantValue(urls.HEIGHT, prodItem)}`;
    }
    else if (urls?.WIDTH_HEIGHT_GROUP.includes(mark?.groupId))
      dimensions = `${getVariantValue(urls.WIDTH, prodItem)} x ${getVariantValue(urls.HEIGHT, prodItem)}`;
    else if (urls?.DIAMETER_GROUP.includes(mark?.groupId))
      dimensions = `${getVariantValue(urls.DIAMETER, prodItem)}`;
    else
      return null;
    return (
      <Text style={quoteStyles.modelProductListDetailTableCell} break>
        {dimensions}
      </Text>
    );
  };

  const calculateTotalDdp = (itemListPrice, mark) => {
    // const salesMargin = values?.salesMarginPercentage * 1 / 100;
    // return parseFloat((itemListPrice * mark?.multiplier) / (1 - (salesMargin + mark?.ddpPercentage)));
      return parseFloat((itemListPrice * mark?.multiplier) / (1 - (mark?.ddpPercentage)));
  };
  return (
    <Document>
      <Page size="A4" style={quoteStyles.page}>
        <HeaderComponent distributorList={distributorList} />
        <View style={quoteStyles.table}>
          {/* Table Header */}
          <View style={quoteStyles.tableRow}>
            <View
              style={[
                quoteStyles.tableLeftCol,
                { borderRightWidth: 1, borderRightColor: "#63707E" },
              ]}
            >
              <View style={quoteStyles.tableRow}>
                <View style={quoteStyles.tableHeadCol}>
                  <Text style={quoteStyles.tableHeadCell}>Customer</Text>
                </View>
                <View>
                  <Text style={quoteStyles.tableColonCell}>
                    :</Text>
                </View>
                <View style={quoteStyles.tableCol}>
                  <Text style={quoteStyles.tableCell}>{customerObj?.customerName}</Text>
                </View>
              </View>
              <View style={quoteStyles.tableRow}>
                <View style={quoteStyles.tableHeadCol}>
                  <Text style={quoteStyles.tableHeadCell}>Address</Text>
                </View>
                <View>
                  <Text style={quoteStyles.tableColonCell}>
                    :</Text>
                </View>
                <View style={quoteStyles.tableCol}>
                  <Text style={quoteStyles.tableCell}>{quotePDFDetails?.data?.customerAddress}</Text>
                </View>
              </View>
              <View style={quoteStyles.tableRow}>
                <View style={quoteStyles.tableHeadCol}>
                  <Text style={quoteStyles.tableHeadCell}>Contact Person</Text>
                </View>
                <View>
                  <Text style={quoteStyles.tableColonCell}>
                    :</Text>
                </View>
                <View style={quoteStyles.tableCol}>
                  <Text style={quoteStyles.tableCell}>{quotePDFDetails?.data?.contactPerson}</Text>
                </View>
              </View>
              <View style={quoteStyles.tableRow}>
                <View style={quoteStyles.tableHeadCol}>
                  <Text style={quoteStyles.tableHeadCell}>Contact #</Text>
                </View>
                <View>
                  <Text style={quoteStyles.tableColonCell}>
                    :</Text>
                </View>
                <View style={quoteStyles.tableCol}>
                  <Text style={quoteStyles.tableCell}>{quotePDFDetails?.data?.phone}</Text>
                </View>
              </View>
            </View>
            <View style={quoteStyles.tableRightCol}>
              <View style={quoteStyles.tableRow}>
                <View style={quoteStyles.tableHeadCol}>
                  <Text style={quoteStyles.tableHeadCell}>Quote Ref</Text>
                </View>
                <View>
                  <Text style={quoteStyles.tableColonCell}>
                    :</Text>
                </View>
                <View style={quoteStyles.tableCol}>
                  <Text style={quoteStyles.tableCell}>{quotePDFDetails?.data?.quoteReference}</Text>
                </View>
              </View>
              <View style={quoteStyles.tableRow}>
                <View style={quoteStyles.tableHeadCol}>
                  <Text style={quoteStyles.tableHeadCell}>Date</Text>
                </View>
                <View>
                  <Text style={quoteStyles.tableColonCell}>
                    :</Text>
                </View>
                <View style={quoteStyles.tableCol}>
                  <Text style={quoteStyles.tableCell}>{formatDate(quotePDFDetails?.data?.createdAt, "")}</Text>
                </View>
              </View>
              <View style={quoteStyles.tableRow}>
                <View style={quoteStyles.tableHeadCol}>
                  <Text style={quoteStyles.tableHeadCell}>Customer Email</Text>
                </View>
                <View>
                  <Text style={quoteStyles.tableColonCell}>
                    :</Text>
                </View>
                <View style={quoteStyles.tableCol}>
                  <Text style={quoteStyles.tableCell}>{quotePDFDetails?.data?.emailAddress}</Text>
                </View>
              </View>
              <View style={quoteStyles.tableRow}>
                <View style={quoteStyles.tableHeadCol}>
                  <Text style={quoteStyles.tableHeadCell}>Sales Eng</Text>
                </View>
                <View>
                  <Text style={quoteStyles.tableColonCell}>
                    :</Text>
                </View>
                <View style={quoteStyles.tableCol}>
                  <Text style={quoteStyles.tableCell}>{salesEngObj?.firstName + " " + salesEngObj?.lastName}</Text>
                </View>
              </View>
              <View style={quoteStyles.tableRow}>
                <View style={quoteStyles.tableHeadCol}>
                  <Text style={quoteStyles.tableHeadCell}>Contact</Text>
                </View>
                <View>
                  <Text style={quoteStyles.tableColonCell}>
                    :</Text>
                </View>
                <View style={quoteStyles.tableCol}>
                  <Text style={quoteStyles.tableCell}>{listData?.data?.phone}</Text>
                </View>
              </View>
            </View>
          </View>
          <View style={quoteStyles.projectTableRow}>
            <View style={quoteStyles.tableProjectCol}>
              <View style={quoteStyles.tableProjectRow}>
                <View style={quoteStyles.projectTableHeadCol}>
                  <Text style={quoteStyles.tableHeadProjectCell}>Project</Text>
                </View>
                <View>
                  <Text style={quoteStyles.tableColonProjectCell}>:</Text>
                </View>
                <View style={quoteStyles.tableProjectCol}>
                  <Text style={quoteStyles.tableProjectCell}>{projectObj?.projectName}</Text>
                </View>
              </View>
            </View>
          </View>
        </View>
        <Text style={quoteStyles.proposalText}>
          Dear Sir/Madam, {"\n"}We thank you for your enquiry and
          are pleased to submit our proposal as follows:
        </Text>
        {markDetails?.map((mark, index) => {
          let totalPrice = 0;
          return (<>
            <View style={quoteStyles.modelProductTable}>
              <View style={quoteStyles.modelProductTableRow}>
                <View style={quoteStyles.modelProductTableColumn}>
                  <Text style={quoteStyles.modelProductTableKeyCell}>MODEL :</Text>
                  <Text style={quoteStyles.modelProductTableValueCell}>{mark?.productName}</Text>
                </View>
                <View style={quoteStyles.productTableColumn}>
                  <Text style={quoteStyles.productTableKeyCell}>
                    PRODUCT :
                  </Text>
                  <Text style={quoteStyles.productTableValueCell}>
                    {mark?.groupName}
                  </Text>
                </View>
              </View>
              {renderSpecifications(mark)}
            </View>
            <View style={quoteStyles.modelProductListDetailsTable} wrap={true}>
              <View style={quoteStyles.modelProductListDetailRow}>
                <View style={quoteStyles.modelProductListDetailSlHeadColumn}>
                  <Text style={quoteStyles.modelProductListDetailTableHeadCell}>#</Text>
                </View>
                <View style={quoteStyles.modelProductListDetailTagRefHeadColumn}>
                  <Text style={quoteStyles.modelProductListDetailTableHeadCell}>
                    Tag Ref.
                  </Text>
                </View>
                <View style={quoteStyles.modelProductListDetailSizeHeadColumn}>
                  {
                    renderProductHeading(mark)
                  }
                </View>
                <View style={quoteStyles.modelProductListDetailQtyHeadColumn}>
                  <Text style={quoteStyles.modelProductListDetailTableHeadCell}>Qty {'\n'} (nos)</Text>
                </View>
                <View style={quoteStyles.modelProductListDetailUnitHeadColumn}>
                  <Text style={quoteStyles.modelProductListDetailTableHeadCell}>
                    Unit Price {'\n'} ({currencyDetail?.shortCode})
                  </Text>
                </View>
                <View style={quoteStyles.modelProductListDetailTotalHeadColumn}>
                  <Text style={quoteStyles.modelProductListDetailTableHeadCell}>Total Price {'\n'} ({currencyDetail?.shortCode})</Text>
                </View>
                <View style={quoteStyles.modelProductListDetailNotesHeadColumn}>
                  <Text style={quoteStyles.modelProductListDetailTableHeadCell}>Notes</Text>
                </View>
              </View>
              {
                mark?.productItems?.map((prodItem, prodIndex) => {
                  let unitPrice = prodItem?.productItemVariants?.find(filterItem => urls?.UNIT_PRICE_CONSTANT.includes(filterItem?.variantId))?.variantValue || 0
                  let itemListPrice = prodItem?.productItemVariants?.find(filterItem => urls?.LIST_PRICE_CONSTANT.includes(filterItem?.variantId))?.variantValue || 0
                  let quantity = prodItem?.productItemVariants?.find(filterItem => urls?.QUANTITY_CONSTANT.includes(filterItem?.variantId))?.variantValue || 0
                  let listPrice = calculateTotalDdp(itemListPrice, mark)

                  totalPrice = ((totalPrice || 0) * 1) + (listPrice * quantity)
                  totalDdp = ((totalDdp || 0) * 1) + (listPrice * quantity)
                  let filterVariant = variantData?.find(varItem => varItem.markId === prodItem?.quoteProductId)?.result
                  let includePrint = filterVariant?.data?.filter(item => item.includeInPrint === true)
                  return (
                    <View style={quoteStyles.modelProductListDimensionDetailRow}>
                      <View style={quoteStyles.modelProductListDetailSlColumn}>
                        <Text style={quoteStyles.modelProductListDetailTableCell}>{prodIndex + 1}</Text>
                      </View>
                      <View style={quoteStyles.modelProductListDetailTagRefColumn} wrap={true}>
                        <Text style={quoteStyles.modelProductListDetailTableCell}>
                          {prodItem?.productItemVariants?.find(filterItem => urls?.TAG_REF_CONSTANT.includes(filterItem?.variantId))?.variantValue}
                        </Text>
                      </View>
                      <View style={quoteStyles.modelProductListDetailSizeColumn} wrap={true}>
                        {
                          renderProductDetail(mark, prodItem)
                        }
                      </View>
                      <View style={quoteStyles.modelProductListDetailQtyColumn}>
                        <Text style={quoteStyles.modelProductListDetailTableCell}>{prodItem?.productItemVariants?.find(filterItem => urls?.QUANTITY_CONSTANT.includes(filterItem?.variantId))?.variantValue}</Text>
                      </View>
                      <View style={quoteStyles.modelProductListDetailUnitColumn}>
                        <Text style={quoteStyles.modelProductListDetailTableCell}>
                          {FormatValueDecimal(CurrencyConvertion(listPrice, quotePDFDetails?.data?.conversionRate, currencyDetail))}
                        </Text>
                      </View>
                      <View style={quoteStyles.modelProductListDetailTotalColumn}>
                        <Text style={quoteStyles.modelProductListDetailTableCell}>
                          {FormatValueDecimal(CurrencyConvertion(listPrice * quantity, quotePDFDetails?.data?.conversionRate, currencyDetail))}
                        </Text>
                      </View>
                      <View style={quoteStyles.modelProductListDetailNotesColumn}>
                        {includePrint?.length > 0 && (
                          <Text style={quoteStyles.modelProductListDetailTableFaceSizeCell}>
                            <>
                              Face Size(mm):
                              {includePrint
                                ?.map(inprintItem =>
                                  prodItem?.productItemVariants?.find(
                                    filterItem => inprintItem?.variantId === filterItem?.variantId
                                  )?.variantValue || 0
                                )
                                .join(" x ")}
                            </>
                          </Text>
                        )}
                        {prodItem?.notes?.length > 0 && (
                          <Text style={quoteStyles.modelProductListDetailTableNoteCell} wrap={true}>
                            {prodItem?.notes}
                          </Text>
                        )}
                      </View>
                    </View>
                  )
                })
              }
              <View style={quoteStyles.modelProductListDetailRow}>
                <View style={quoteStyles.modelProductListDetailSlSubTotalColumn}>
                  <Text style={quoteStyles.modelProductListDetailTableCell}></Text>
                </View>
                <View style={quoteStyles.modelProductListDetailTagRefSubTotalColumn}>
                  <Text style={quoteStyles.modelProductListDetailTableCell}>
                  </Text>
                </View>
                <View style={quoteStyles.modelProductListDetailSizeSubTotalColumn}>
                  <Text style={quoteStyles.modelProductListDetailTableCell}>
                  </Text>
                </View>
                <View style={quoteStyles.modelProductListDetailQtySubTotalColumn}>
                  <Text style={quoteStyles.modelProductListDetailTableCell}>
                  </Text>
                </View>
                <View style={quoteStyles.modelProductListDetailUnitSubTotalColumn}>
                  <Text style={[quoteStyles.modelProductListDetailTableCell, { paddingRight: "10px" }]}>
                    Sub Total :
                  </Text>
                </View>
                <View style={quoteStyles.modelProductListDetailTotalSubTotalColumn}>
                  <Text style={[quoteStyles.modelProductListDetailTableCell, { paddingRight: "10px" }]}>
                    {FormatValueDecimal(CurrencyConvertion(totalPrice, quotePDFDetails?.data?.conversionRate, currencyDetail))}
                  </Text>
                </View>
                <View style={quoteStyles.modelProductListDetailNotesSubTotalColumn}>
                  <Text style={quoteStyles.modelProductListDetailTableCell}>
                  </Text>
                </View>
              </View>
            </View>
          </>)
        })}
        <View style={quoteStyles.detailsTable}>
          {quotePDFDetails?.data?.netPrice > 0 && (<View style={quoteStyles.detailsTableRow}>
            <View style={quoteStyles.detailsTableColumn}>
              <Text style={[quoteStyles.detailsTableCell, { paddingTop: "5px" }]}>Net Price :</Text>
            </View>
            <View style={quoteStyles.detailsQarTableColumn}>
              <Text style={[quoteStyles.detailsQarTableCell, { paddingTop: "5px" }]}>{currencyDetail?.shortCode}</Text>
            </View>
            <View style={quoteStyles.detailsPriceTableColumn}>
              <Text style={[quoteStyles.detailsPriceTableCell, { paddingTop: "5px" }]}>{FormatValueDecimal(CurrencyConvertion(totalDdp, quotePDFDetails?.data?.conversionRate, currencyDetail))}</Text>
            </View>
          </View>)}
          {/* {quotePDFDetails?.data?.specialCharges > 0 && (<View style={quoteStyles.detailsTableRow}>
            <View style={quoteStyles.detailsTableColumn}>
              <Text style={quoteStyles.detailsTableCell}>Special Colour Charges :</Text>
            </View>
            <View style={quoteStyles.detailsQarTableColumn}>
              <Text style={quoteStyles.detailsQarTableCell}>{currencyDetail?.shortCode}</Text>
            </View>
            <View style={quoteStyles.detailsPriceTableColumn}>
              <Text style={quoteStyles.detailsPriceTableCell}>{FormatValueDecimal(CurrencyConvertion(quotePDFDetails?.data?.specialCharges, quotePDFDetails?.data?.conversionRate, currencyDetail))}</Text>
            </View>
          </View>)} */}
          {(quotePDFDetails?.data?.tax > 0 || quotePDFDetails?.data.taxPercentage > 0) && (<View style={quoteStyles.detailsTableRow}>
            <View style={quoteStyles.detailsTableColumn}>
              <Text style={quoteStyles.detailsTableCell}>Taxes / VAT {quotePDFDetails?.data?.tax > 0 ? "" : "@ " + quotePDFDetails?.data.taxPercentage + "%"} :</Text>
            </View>
            <View style={quoteStyles.detailsQarTableColumn}>
              <Text style={quoteStyles.detailsQarTableCell}>{currencyDetail?.shortCode}</Text>
            </View>
            <View style={quoteStyles.detailsPriceTableColumn}>
              <Text style={quoteStyles.detailsPriceTableCell}>
                  {quotePDFDetails?.data?.tax > 0 ? FormatValueDecimal(CurrencyConvertion(quotePDFDetails?.data?.tax, quotePDFDetails?.data?.conversionRate, currencyDetail)) :
                  FormatValueDecimal(CurrencyConvertion(((((values?.totalLandedCost * 1)) * 1) * ((values?.taxPercentage * 1) / 100)), quotePDFDetails?.data?.conversionRate, currencyDetail))}
                {/* {quotePDFDetails?.data?.tax > 0 ? FormatValueDecimal(CurrencyConvertion(quotePDFDetails?.data?.tax, quotePDFDetails?.data?.conversionRate, currencyDetail)) :
                  FormatValueDecimal(CurrencyConvertion(((((values?.totalLandedCost * 1) / (1 - (values?.salesMarginPercentage / 100))) * 1) * ((values?.taxPercentage * 1) / 100)), quotePDFDetails?.data?.conversionRate, currencyDetail))} */}
                  </Text>
            </View>
          </View>)}
          {/* {quotePDFDetails?.data?.totalSellingPrice > 0 && (<View style={quoteStyles.detailsTableRow}>
            <View style={quoteStyles.detailsTableColumn}>
              <Text style={quoteStyles.detailsTableCell}>Total Selling Price :</Text>
            </View>
            <View style={quoteStyles.detailsQarTableColumn}>
              <Text style={quoteStyles.detailsQarTableCell}>{currencyDetail?.shortCode}</Text>
            </View>
            <View style={quoteStyles.detailsPriceTableColumn}>
              <Text style={quoteStyles.detailsPriceTableCell}>{FormatValueDecimal(CurrencyConvertion(quotePDFDetails?.data?.totalSellingPrice, quotePDFDetails?.data?.conversionRate, currencyDetail))}</Text>
            </View>
          </View>)} */}
          {quotePDFDetails?.data?.grandTotal > 0 && (<View style={[quoteStyles.totalDetailsTableRow, { borderTop: "1px solid #63707E" }]}>
            <View style={quoteStyles.totalDetailsTableColumn}>
              <Text style={[quoteStyles.totalDetailsTableCell, { paddingTop: "5px", paddingBottom: "5px" }]}></Text>
            </View>
            <View style={quoteStyles.totalDetailsPriceTableColumn}>
              <Text style={[quoteStyles.totalDetailsPriceTableCell, { paddingTop: "5px", paddingBottom: "5px" }]}></Text>
            </View>
            <View style={quoteStyles.grandTotalDetailsTableColumn}>
              <Text style={[quoteStyles.totalDetailsTableCell, { paddingTop: "5px", paddingBottom: "5px" }]}>Grand Total :</Text>
            </View>
            <View style={quoteStyles.grandTotalDetailsQarTableColumn}>
              <Text style={[quoteStyles.detailsQarTableCell, { paddingTop: "5px", paddingBottom: "5px" }]}>{currencyDetail?.shortCode}</Text>
            </View>
            <View style={quoteStyles.grandTotalDetailsPriceTableColumn}>
              <Text style={[quoteStyles.detailsPriceTableCell, { paddingTop: "5px", paddingBottom: "5px" }]}>{FormatValueDecimal(CurrencyConvertion(quotePDFDetails?.data?.grandTotal, quotePDFDetails?.data?.conversionRate, currencyDetail))}</Text>
            </View>
          </View>)}
          {quotePDFDetails?.data?.grandTotal > 0 && (<View style={[quoteStyles.totalDetailsTableRow, { borderTop: "1px solid #63707E" }]}>
            <View style={quoteStyles.totalDetailsTableColumn}>
              <Text style={[quoteStyles.totalDetailsTableCell, { paddingLeft: "5px" }]}>TOTAL (in words) :</Text>
            </View>
            <View style={quoteStyles.totalDetailsFullPriceTableColumn}>
              <Text style={[quoteStyles.totalDetailsPriceTableCell, { paddingTop: "5px", paddingBottom: "5px" }]}>{numberToWords(CurrencyConvertion(quotePDFDetails?.data?.grandTotal, quotePDFDetails?.data?.conversionRate, currencyDetail), currencyDetail)}</Text>
            </View> 
          </View>)}
        </View>
        <View style={quoteStyles.termsandConditionTable}>
          <View style={quoteStyles.termsandConditionTableRow}>
            <View style={[{ marginBottom: "10px" }]}>
              <Text
                style={quoteStyles.termsandConditionTableHeadingCell}>
                Terms & Conditions
              </Text>
            </View>
          </View>
          <View style={quoteStyles.termsandConditionTableRow}>
            <View style={quoteStyles.termsandConditionTableColumn}>
              <Text style={quoteStyles.termsandConditionTableHeadCell}>
                Payment Terms</Text>
            </View>
            <View>
              <Text style={quoteStyles.termsandConditionColonTableCell}>
                :</Text>
            </View>
            <View>
              <Text style={quoteStyles.termsandConditionTableCell}>
                {quotePDFDetails?.data?.paymentTerms || paymentTermsList?.find(item => item?.id === quotePDFDetails?.data?.paymentTermId)?.paymentDescription}
              </Text>
            </View>
          </View>
          <View style={quoteStyles.termsandConditionTableRow}>
            <View>
              <Text style={quoteStyles.termsandConditionTableHeadCell}>
                Delivery Terms</Text>
            </View>
            <View>
              <Text style={quoteStyles.termsandConditionColonTableCell}>
                :</Text>
            </View>
            <View>
              <Text style={quoteStyles.termsandConditionTableCell}>
                {quotePDFDetails?.data?.deliveryTerms || deliveryTermsList?.find(item => item?.id === quotePDFDetails?.data?.deliveryTermId)?.deliveryDescription
                  || quotePDFDetails?.data?.destination}
                {countryList?.find(country => country?.id === quotePDFDetails?.data?.destinationCountryId)?.name
                  && (countryList?.find(country => country?.id === quotePDFDetails?.data?.destinationCountryId)?.name)}
              </Text>
            </View>
          </View>
          <View style={quoteStyles.termsandConditionTableRow}>
            <View>
              <Text style={quoteStyles.termsandConditionTableHeadCell}>
                Delivery Period</Text>
            </View>
            <View>
              <Text style={quoteStyles.termsandConditionColonTableCell}>
                :</Text>
            </View>
            <View>
              <Text style={quoteStyles.termsandConditionTableCell}>
                As per the project requirement
              </Text>
            </View>
          </View>
          <View style={quoteStyles.termsandConditionTableRow}>
            <View>
              <Text style={quoteStyles.termsandConditionTableHeadCell}>
                Validity</Text>
            </View>
            <View>
              <Text style={quoteStyles.termsandConditionColonTableCell}>
                :</Text>
            </View>
            <View>
              <Text style={quoteStyles.termsandConditionTableCell}>
                {quotePDFDetails?.data?.quoteValidity} days from the date hereof and thereafter subject to our written confirmation.
              </Text>
            </View>
          </View>
          <View style={quoteStyles.termsandConditionTableRow}>
            <View>
              <Text style={quoteStyles.termsandConditionTableHeadCell}>
                Warranty</Text>
            </View>
            <View>
              <Text style={quoteStyles.termsandConditionColonTableCell}>
                :</Text>
            </View>
            <View>
              <Text style={quoteStyles.termsandConditionTableCell}>
                Goods manufactured by Jersey Manufacturing carry a standard warranty of 12 months from the date of
                supply, against all manufacturing defects, subject to our warranty policy - (can be provided on request).
              </Text>
            </View>
          </View>
          <View style={[quoteStyles.declarationTable, { marginTop: "20px" }]}>
            <View style={quoteStyles.declarationTableRow}>
              <View>
                <Text style={quoteStyles.italicFooterText} break>
                  We once again thank you for the opportunity to quote for your
                  requirement. Please feel free to contact us in case of any
                  clarification.Thanking you and assuring you our best attention and services at all times.
                </Text>
              </View>
            </View>
            <View style={quoteStyles.declarationTableRow}>
              <View>
                <Text style={quoteStyles.boldFooterText}>
                  For, Jersey Manufacturing for Airconditioning Products
                </Text>
              </View>
            </View>
            <View style={[quoteStyles.footerTableRow, { marginTop: "10px" }]}>
              <View style={[quoteStyles.footerTableColumn, { width: "50%" }]}>
                <Text
                  style={[
                    quoteStyles.footerTableCell,
                    {
                      paddingLeft: "20px",
                      textAlign: "left",
                      fontSize: "10px",
                    },
                  ]}
                >
                  Sales Engineer{"\n"}
                </Text>
              </View>
              <View style={[quoteStyles.footerTableColumn, { width: "50%" }]}>
                <Text
                  style={[
                    quoteStyles.footerTableCell,
                    {
                      paddingRight: "20px",
                      textAlign: "right",
                      fontSize: "10px",
                    },
                  ]}
                >
                  Divisional manager
                </Text>
              </View>
            </View>
          </View>
        </View>
        <FooterComponent values={quotePDFDetails?.data} distributorList={distributorList} />
      </Page >
      <Page size="A4" style={[quoteStyles.page, { paddingBottom: "100px" }]}>
        <TermsAndConditionHeaderComponent distributorList={distributorList} />
        <TermsAndConditionPDF />
        <TermsAndConditionFooterComponent values={quotePDFDetails?.data} distributorList={distributorList} />
      </Page>
    </Document >
  );
};
